import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import {
  TransactionLogAnalysisPrompt,
  TransactionLogPayload,
  TransactionLogSearchRequest,
  TransactionLogSearchResult,
  TransactionLogTimeline,
} from "../../models/domains/pbm/transaction-log/transaction-log.model";

@Injectable()
export class TransactionLogRepository {
  private readonly headers = { "Content-Type": "application/json" };

  constructor(private remoteGatewayFactory: RemoteGatewayFactory) {}

  public async search(request: TransactionLogSearchRequest): Promise<TransactionLogSearchResult> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/transaction-log/search");
    return (await remoteGateway.postWithHeaders(backendUrl, JSON.stringify(request), this.headers)) as TransactionLogSearchResult;
  }

  public async getTimeline(transactionKey: string): Promise<TransactionLogTimeline> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/transaction-log/" + encodeURIComponent(transactionKey));
    return (await remoteGateway.getWithHeaders(backendUrl, this.headers)) as TransactionLogTimeline;
  }

  public async getAnalysisPrompt(transactionKey: string, question: string): Promise<TransactionLogAnalysisPrompt> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/transaction-log/analysis-prompt");
    const body = JSON.stringify({ TransactionKey: transactionKey, Question: question || null });
    return (await remoteGateway.postWithHeaders(backendUrl, body, this.headers)) as TransactionLogAnalysisPrompt;
  }

  public async getPayload(eventId: number): Promise<TransactionLogPayload> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/transaction-log/events/" + eventId + "/payload");
    return (await remoteGateway.getWithHeaders(backendUrl, this.headers)) as TransactionLogPayload;
  }
}
